module.exports = __webpack_public_path__ + "static/img/icon8.9ec40007.png";